/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Break_AfterInputs */



/**
* | output |
* | --- |
* | "New line after" |
*
* @param {Transcript_Export_Break_AfterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_break_after = /** @type {((inputs?: Transcript_Export_Break_AfterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Break_AfterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("New line after")
	if (locale === "de") return /** @type {LocalizedString} */ ("New line after")
	if (locale === "it") return /** @type {LocalizedString} */ ("New line after")
	if (locale === "ru") return /** @type {LocalizedString} */ ("New line after")
	if (locale === "es") return /** @type {LocalizedString} */ ("New line after")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("New line after")
	if (locale === "ja") return /** @type {LocalizedString} */ ("New line after")
	if (locale === "hi") return /** @type {LocalizedString} */ ("New line after")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("New line after")
	return /** @type {LocalizedString} */ ("New line after")
});